export default "__VITE_ASSET__3z9mcEGV__"